import { RequestContext } from '@fiverr-private/perseus';
import { LogEntity, logger as obsLogger } from '@fiverr-private/obs';

const error = (message: LogEntity, details = {}) => {
    const { url, pathParameters, queryParameters, userGuid, pageCtxId, userAgent } = RequestContext;

    obsLogger.error(message, {
        ...details,
        meta: {
            url,
            pathParameters,
            queryParameters,
            userGuid,
            pageCtxId,
            userAgent,
        },
    });
};

export const logger = {
    error,
};
